<template>
    <div class="main-board">
        <div class="main-board__head">
            <h3 class="text-28 text-md-22">공지사항</h3>
            <router-link to="/center/notice" class="main-board__more"><span class="d-sr-only">더보기</span></router-link>
        </div>
        <div class="main-board__body">
            <div class="main-board-items">
                <div v-if="!items.length" class="main-board-item">
                    공지사항이 없습니다.
                </div>
                <router-link v-for="{ _id, subject, createdAt } in items" :key="_id" :to="`/center/notice/${_id}`" class="main-board-item">
                    <div class="main-board-item__tit">{{ subject }}</div>
                    <span class="main-board-item__date">{{ createdAt.toDate() }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
export default {
    computed: {
        items() {
            return [...(this.fixed || []), ...(this.notifications || [])];
        },
    },
    data() {
        return {
            limit: 5,

            fixed: [],
            notifications: [],
        };
    },
    methods: {
        async search() {
            let { limit } = this;
            var { notifications: fixed } = await api.v1.center.notifications.gets({
                headers: { limit },
                params: { isNotice: true, sites: "yknowledge" },
            });
            this.fixed = fixed;

            limit -= fixed.length;
            if (limit) {
                var { notifications } = await api.v1.center.notifications.gets({
                    headers: { limit },
                    params: { isNotice: false, sites: "yknowledge" },
                });
                this.notifications = notifications;
            }
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style></style>
